// extracted by mini-css-extract-plugin
module.exports = {"link":"link-a6113708","dark":"dark-b6aec655","light":"light-81cc2228"};